import { useEffect, useState } from 'react'
import ScheduleType from './Steps/ScheduleType';
import ScheduleLocales from './Steps/ScheduleLocales';
import PopUp from './PopUp'
import useFormattedCPF from '../../hooks/useFormatedCpf';
import useFormattedCNPJ from '../../hooks/useFormattedCNPJ';
import { Order, ScheduleDetails } from '../../types/types';
import ButtonSendData from './ButtonSendData';
import { useSchedule } from '../../context/ScheduleContext';
import { useWindowSize } from '../../hooks/useDevice';
import Videoconference from './Steps/Videoconference';
import { pushToDataLayer } from '../../types/gtm';
import {
  Aside,
  Container,
  ButtonValidation,
  Subtitle,
  Paragraph,
  List,
  ListItem,
  ContainerRow,
} from './styles'
import Icon from '../ui/Icon';
import Final from './Final';
interface ValidationServiceProps {
  order: Order | null;
}

export const ValidationService = ({ order }: ValidationServiceProps) => {
  const FormattedCpf = useFormattedCPF({ cpf: order?.cpf });
  const FormattedCnpj = useFormattedCNPJ({ cnpj: order?.historicoPessoaJuridica?.cnpj });
  const [scheduleInfos, setScheduleInfos] = useState<ScheduleDetails>()
  const [step, setStep] = useState<number>(1);
  const [isVideoConference, setIsVideoConference] = useState(false);
  const [validationType, setValidationType] = useState('');
  const [schedule, setSchedule] = useState<boolean>(false)
  const { setData } = useSchedule();
  const [hasMidia, setHasMidia] = useState<boolean>(false);
  const [selectAc, setSelectAc] = useState<boolean>(false);
  const { width } = useWindowSize();
  const isDevice = Number(width) < 1295;

  useEffect(() => {
    if (order) {
      setHasMidia(order.produto.contemMidia);
    }
  }, [order]);
  const ProductInfos = {
    productName: order?.produto.descricao,
    cpf: FormattedCpf,
    cnpj: FormattedCnpj,
    email: order.email
  };

  const handlePopVideoConference = () => {
    setIsVideoConference(!isVideoConference);
  }

  const handleValidationType = (type: string) => {
    setValidationType(type);
    setStep(2);
    if (type) {
      pushToDataLayer({
        event: 'select_content',
        content_type: `validacao-${type}`
      })
    }
  }

  const handleSchedulingSuccess = () => {
    setStep(3);
  }

  const renderStep = () => {
    const stepComponents: { [key: number]: JSX.Element } = {
      1: <ScheduleType hasMidia={hasMidia} onPopVideoConference={handlePopVideoConference} onPresential={() => handleValidationType('presential')} />,
      2: validationType === 'videoconference'
        ? <Videoconference setSelectAc={setSelectAc} orderId={order.id} />
        : <ScheduleLocales isVideoConference={validationType} order={order} validationType={validationType} />,
      3: <Final productInfos={ProductInfos} scheduleInfos={scheduleInfos} choiceAc={selectAc} order={order} isVideoconference={validationType === 'videoconference'} />,
    }
    return stepComponents[step] || null;
  }

  const renderValidationTypeSection = () => {
    return (
      <>
        <Paragraph className='validationType'>Tipo de agendamento</Paragraph>
        <ContainerRow>
          <Subtitle>
            {
              validationType === 'videoconference' ?
                <Icon name='Video' width={22} height={22} fill='var(--ins-blue)' /> :
                <Icon name='User' width={22} height={22} fill='var(--ins-blue)' />
            }
            {validationType === 'videoconference' ? 'Videoconferência' : 'Presencial'}
          </Subtitle>
          <ButtonValidation onClick={() => { handleValidationType(''); setStep(1) }}>
            <Icon name="Change" width={16} height={16} fill='var(--ins-blue)' />
            Alterar
          </ButtonValidation>
        </ContainerRow>
      </>
    )
  }

  useEffect(() => {
    setData(prevState => ({
      ...prevState,
      detalhePosto: {
        ...prevState.detalhePosto,
        videoconferencia: validationType === 'videoconference' ? true : false
      }
    }))
  }, [setData, validationType])

  return (
    <Container>
      {renderStep()}
      {!schedule && isDevice && (
        <>
          {validationType && (
            <ButtonSendData
              order={order}
              choiceAc={selectAc}
              isVideoconference={validationType === 'videoconference'}
              onSuccess={handleSchedulingSuccess}
              schedule={schedule}
              setSchedule={setSchedule}
              setScheduleInfos={setScheduleInfos} />
          )}
        </>
      )}
      {!schedule && (
        <Aside>
          {validationType && renderValidationTypeSection()}
          <List>
            <ListItem><strong>{order?.produto.descricao}</strong></ListItem>
            <ListItem>{FormattedCpf && `CPF: ${FormattedCpf}`}</ListItem>
            <ListItem>{FormattedCnpj && `CNPJ: ${FormattedCnpj}`}</ListItem>
          </List>
          {validationType && (
            <ButtonSendData
              order={order}
              choiceAc={selectAc}
              isVideoconference={validationType === 'videoconference'}
              onSuccess={handleSchedulingSuccess}
              schedule={schedule}
              setSchedule={setSchedule}
              setScheduleInfos={setScheduleInfos} />
          )}
        </Aside>
      )}
      {isVideoConference && (
        <PopUp
          handlePopVideoConference={handlePopVideoConference}
          handleValidationType={handleValidationType} />
      )}
    </Container>
  )
}